import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Check, ExternalLink, Wallet, Clock } from 'lucide-react';

const HandoffScreen = ({ userData, buyerData }) => {
  const [countdown, setCountdown] = useState(5);
  
  // Countdown timer for automatic redirect
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);
  
  // Handle redirect to buyer site
  const handleRedirect = () => {
    // In production, use the actual buyer URL
    const buyerUrl = 'https://insurify.com/quotes?source=ownli&ref=12345';
    window.location.href = buyerUrl;
  };
  
  // Auto-redirect when countdown reaches zero
  useEffect(() => {
    if (countdown === 0) {
      handleRedirect();
    }
  }, [countdown]);
  
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center space-y-4">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
          <Check className="w-8 h-8 text-green-500" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Offer Accepted!</h1>
        <p className="text-gray-600">
          Your information has been shared with {buyerData.name}
        </p>
      </div>
      
      {/* Payment Confirmation */}
      <Card className="bg-green-50 border-green-100">
        <CardContent className="pt-6">
          <div className="flex items-start gap-3">
            <Wallet className="w-6 h-6 text-green-500" />
            <div>
              <p className="font-medium text-green-900">Payment Complete</p>
              <p className="text-sm text-green-700">
                ${buyerData.offer.amount.toFixed(2)} has been added to your Ownli wallet
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      {/* Handoff Card */}
      <Card className="border border-blue-100">
        <CardContent className="pt-6">
          <div className="text-center space-y-4">
            {buyerData.logo && (
              <img 
                src={buyerData.logo} 
                alt={buyerData.name} 
                className="h-12 w-auto mx-auto object-contain"
              />
            )}
            
            <div>
              <h2 className="text-xl font-medium text-gray-900">{buyerData.name} is ready for you</h2>
              <p className="text-sm text-gray-600 mt-2">
                You'll be redirected to {buyerData.name} in {countdown} seconds to see your personalized quotes
              </p>
            </div>
            
            <div className="flex items-center justify-center gap-2 mt-2">
              <Clock className="w-4 h-4 text-blue-500" />
              <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                <span className="text-blue-800 font-medium">{countdown}</span>
              </div>
            </div>
            
            <button
              onClick={handleRedirect}
              className="w-full flex items-center justify-center gap-2 bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-colors mt-4"
            >
              Take me to {buyerData.name} now
              <ExternalLink className="w-4 h-4" />
            </button>
          </div>
        </CardContent>
      </Card>
      
      {/* Vehicle Info */}
      <Card>
        <CardContent className="pt-6">
          <div className="space-y-2">
            <h3 className="font-medium text-gray-900">Shared Information</h3>
            <div className="text-sm text-gray-600 space-y-1">
              <p>{userData?.vehicle?.year} {userData?.vehicle?.make} {userData?.vehicle?.model}</p>
              <p>License Plate: {userData?.vehicle?.licensePlate}</p>
              <p>State: {userData?.state}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      {/* Footer */}
      <p className="text-xs text-center text-gray-500">
        You can access your Ownli wallet anytime by visiting the Ownli app or website
      </p>
    </div>
  );
};

export default HandoffScreen;